import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import { AssignedShipments } from '@uturn/portal/modules/shipments';
import {
	SHIPMENTS_SEARCH_DEFAULT_STATUSES_ASSIGNED,
	ShipmentsSearchSchema,
	ShipmentsSearchStatusesSchema,
} from '@uturn/portal/router/schema/shipments-search';

const AssignedShipmentsSearchSchema = ShipmentsSearchSchema.extend({
	'filter.statuses': fallback(
		ShipmentsSearchStatusesSchema.array(),
		SHIPMENTS_SEARCH_DEFAULT_STATUSES_ASSIGNED,
	).default(SHIPMENTS_SEARCH_DEFAULT_STATUSES_ASSIGNED),
});

export const Route = createFileRoute(
	'/_protected/shipments/(overview)/assigned',
)({
	component: AssignedShipments,
	validateSearch: zodValidator(AssignedShipmentsSearchSchema),
});
